import { Topbar } from '@layouts/Library/Topbar'

interface AdminProps {
	children: React.ReactNode
}

export function SuccessLayout({ children }: AdminProps) {
	return (
		<div className='relative w-full h-screen flex flex-col items-center bg-zinc-950'>
			<Topbar />
			<div className='absolute inset-0 overflow-hidden'>
				<img
					src='/imgs/admin/success/bg.png'
					alt='Emoji'
					className='w-full h-full object-cover'
				/>
			</div>
			<div className='relative z-10 w-full flex flex-col min-h-[85vh]'>
				{children}
			</div>
		</div>
	)
}
